let activeService;
// TODO: promise based?
export function setActiveService(service) {
    activeService = service;
}
export function getActiveService() {
    return activeService;
}
